export const ROSTER_WEEKLY_CONFIG = {
  CONTENT_PANEL_WIDTH: 320,
  HOUR_BLOCK_HEIGHT: 64,
  HOUR_BLOCK_WIDTH: 120,
  GROUP_ROW_HEIGHT: 10,
  ITEM_ROW_HEIGHT: 88,
  ITEM_CARD_HEIGHT: 82,
  ITEM_CARD_PADDING: 4,
  FOOTER_BLOCK_HEIGHT: 18,
  SIDEBAR_WIDTH: 216,
};
